import { AppAreaConfig } from '@/funnels/@types'
import walkingFemale from './activity-female-walking'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-nordic-walking-fwf',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-nordic-walking-f', 'age-nordic-walking-f'],
		route: {
			path: '/nordic-walking-f-fwf',
			name: 'female-nordic-walking-fwf-funnel',
		},
	},
	funnel: {
		id: 'ob-female-nordic-walking-fwf',
		route: {
			path: '/nordic-walking-f-fwf/ob/:page*',
			name: 'activity-female-nordic-walking-fwf',
		},
		slug: 'activity-female-nordic-walking-fwf',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: walkingFemale,
				page: 'focus-area',
			},
		},
	},
}

export default appAreaConfig
